/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-19 14:42:59
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-03-29 16:48:37
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorTabbar/Preview/index.tsx
 */
import { TabBarItem } from '@/src/types/common/SalesChannel';
import _ from 'lodash';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { TabBar, ImagePlaceholder } from 'unifyxp-ecomm-components';

import { getCurrentTabBar } from '../slice';

import styles from './style.module.less';
import PreviewContainer from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';

function Preview() {
  const ref = useRef();
  const currentTabBar = useSelector(getCurrentTabBar());
  return (
    <PreviewContainer className={styles.preContainer}>
      <div
        className={styles.hack}
        ref={ref}
        style={{
          paddingBottom:
            currentTabBar && currentTabBar.display === 'scroll'
              ? '0px'
              : '65px',
        }}>
        <ImagePlaceholder width={'100%'} height={'100vh'} />
        {currentTabBar ? (
          <TabBar
            type={currentTabBar.display}
            backgroundColor={currentTabBar.backgroundColor}
            activeColor={currentTabBar.activeColor}
            inactiveColor={currentTabBar.inactiveColor}
            scrollRef={ref}
            activeIndex={0}
            tabs={currentTabBar.tabs.map((v: TabBarItem) => ({
              ...v,
              icon: _.get(v, 'icon.url'),
            }))}
          />
        ) : null}
      </div>
    </PreviewContainer>
  );
}

export default Preview;
